import React, { useState, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { ActionPlansContext } from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import {
  getAccountContracts,
  getActionContract,
} from "services/ConfigServices";
import RTMetersPowers from "./RTMetersPowers";
import SubmitButton from "components/CustomButtons/SubmitButton";

function SelectMetersDialog(props) {
  const { closeModal, setLoading, refetch } = props;

  const actionContext = useContext(ActionContext);
  const { action, setAction } = actionContext;
  const [selectedMeters, setSelectedMeters] = useState(
    action.parameters?.impact?.meters
  );

  const handleSelectedChange = ({ selectedRows }) => {
    selectedRows.map((meter) => (meter.isSelected = true));
    setSelectedMeters(selectedRows);
  };

  const handleSubmit = async () => {
    editListMeters();
    closeModal();
  };

  const editListMeters = async () => {
    let contracts = [];
    let meters = [];

    await axios
      .get(
        getAccountContracts(
          action.parameters.general.groups[0],
          action.parameters?.impact?.energy
        ),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        contracts = res.data.contracts;
      });

    await axios
      .post(
        getActionContract(
          action.parameters.general.groups[0],
          action.parameters?.impact?.energy
        ),
        {
          metersIds: selectedMeters.map((m) => m.uuid),
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        meters = res.data.meters;
      });

    const mergedMeters = selectedMeters.map((m1) => ({
      ...m1,
      details: {
        ...m1.details,
        ...meters.find((m2) => m2.uuid === m1.uuid),
      },
    }));

    mergedMeters.map(
      (m) => delete m.details.uuid && delete m.details.meternumber
    );

    let contractsIds = selectedMeters.map(
      (m) => m.details.associatedcontractid
    );

    const associatedContracts = contracts.filter((c) =>
      contractsIds.includes(c.uuid)
    );

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          meters: mergedMeters,
          associatedContracts,
        },
      },
    }));
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <RTMetersPowers
            selectedMeters={selectedMeters}
            handleSelectedChange={handleSelectedChange}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div style={{ display: "flex", flexDirection: "flex-end" }}>
            <SubmitButton
              //buttonDisabled={buttonDisabled}
              handleSubmit={handleSubmit}
            >
              Valider la sélection
            </SubmitButton>
          </div>
        </GridItem>
      </GridContainer>
    </>
  );
}

export default SelectMetersDialog;
